import { Bell, Check } from 'lucide-react';
import { useEffect, useState } from 'react';
import { apiGet, apiPatch } from '../api/client.js';
import { Button } from '../components/Button.js';
import { Card } from '../components/Card.js';
import { PageHeader } from '../components/PageHeader.js';
import { SafeHtml } from '../components/SafeHtml.js';

interface N {
  id: string;
  subject: string;
  bodyHtml: string;
  readAt: string | null;
  createdAt: string;
}

export function NotificationsPage(): JSX.Element {
  const [items, setItems] = useState<N[]>([]);

  const load = (): void => {
    apiGet<{ items: N[] }>('/api/notifications').then((r) => setItems(r.items));
  };

  useEffect(() => {
    load();
  }, []);

  const markRead = async (id: string): Promise<void> => {
    await apiPatch(`/api/notifications/${id}/read`, {});
    load();
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <PageHeader
        title="Notifications"
        accent="recent"
        sub="Alert digests and one-off messages from automation rules."
      />

      {items.length === 0 ? (
        <Card>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              padding: 14,
              color: 'var(--c-muted)',
              fontSize: 'var(--text-md)',
            }}
          >
            <Bell size={18} />
            <span>No notifications yet. Set up an alert rule under Automation.</span>
          </div>
        </Card>
      ) : (
        items.map((n) => (
          <Card
            key={n.id}
            title={n.subject}
            description={
              n.readAt
                ? `${new Date(n.createdAt).toLocaleString()} · read`
                : `${new Date(n.createdAt).toLocaleString()} · unread`
            }
            action={
              !n.readAt && (
                <Button size="sm" variant="secondary" icon={Check} onClick={() => markRead(n.id)}>
                  Mark read
                </Button>
              )
            }
          >
            <div style={{ fontSize: 'var(--text-md)', lineHeight: 1.55 }}>
              <SafeHtml html={n.bodyHtml} />
            </div>
          </Card>
        ))
      )}
    </div>
  );
}
